"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "22", viewBox: "0 0 30 22", className: "Icon element-card", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h28v20H1z" }),
            _react2.default.createElement("path", { d: "M1 21h28V1H1v20zM0 0h30v22H0V0z", fill: "#A5A5A5" }),
            _react2.default.createElement("path", { fill: "#929292", d: "M5 5h20v1H5zM5 8h18v1H5zM5 11h20v1H5zM5 14h17v1H5z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/element-card.js
// module id = 1859
// module chunks = 0